export default "__VITE_ASSET__CrX1hiQR__"